import { c as _c } from "react/compiler-runtime";
import MarkdownBase from 'markdown-to-jsx';
import styles from './Markdown.module.css';
interface MarkdownProps {
  children: string | null | undefined;
  className?: string;
}
const Markdown = t0 => {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  const t1 = `${styles.markdownContent}${className ? ` ${className}` : ""}`;
  let t2;
  if ($[0] !== children) {
    t2 = <MarkdownBase>{children}</MarkdownBase>;
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export { Markdown };